import styled from '@emotion/styled'
import { IconButton } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const CloseButton = styled(IconButton)`
  width: ${theme.spacing['2xm']};
  height: ${theme.spacing['2xm']};
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.spacing.xs};
  padding: 0px;
`

export const Wrapper = styled.div`
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  background-color: rgba(0, 0, 0, 0.5);

  .react-transform-wrapper {
    border-radius: ${theme.shapes.borderRadius.sm};
    background-color: ${theme.colors.neutral.clear};
    width: 100%;
    height: 100%;
  }
`

export const Content = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 24px;
  width: 44vw;
  height: 96vh;
  padding: 24px;
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  box-shadow: ${theme.effects.boxShadow['rule-01']};

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    height: 92vh;
    width: 96vw;
    bottom: -24px;
  }
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h5`
  margin: 0;
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2md']};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.high};
`
